import { render, staticRenderFns } from "./ChangeStatus.vue?vue&type=template&id=16831ae0&"
import script from "./ChangeStatus.vue?vue&type=script&lang=js&"
export * from "./ChangeStatus.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/SalesManagement/SalesManagementChangeStatus/ChangeStatusStyle.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports